import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  leftSide: (props: { baseColors: BaseColors }) => {
    return {
      height: '100%',
      maxWidth: '40%',
      minWidth: 'fit-content',
      width: '420px',
      boxShadow: `-10px 0px 20px 5px ${props.baseColors.primary}`,
      zIndex: 30,
    }
  },
}))

export default buildStyles
